export default __webpack_public_path__ + "static/media/owl.af7671c1.png";